import { composeReducers } from 'redux-toolbelt';
import links from './links';

export default composeReducers({
  links
});